const AVAILABLE_PAGE: Array<string> = ['/', '/account', '/guides'];

export const getIsAvailablePage = (data: string): boolean =>
  AVAILABLE_PAGE.includes(data);
